import { accountSelectors, recordingsAuthSelectors } from '@lifesize/nucleus';
import { activeFeatureStatus } from 'constants/accountSettingsConstants';
import { PermissionTypes } from 'constants/permissionsConstants';
import _cloneDeep from 'lodash/cloneDeep';
import _get from 'lodash/get';
import React from 'react';
import { connect } from 'react-redux';
import { selectPermissionsObject } from 'selectors/permissionsSelector';
import { Global } from 'state/Global';
import { PermissionsState } from 'state/Permissions';
import { hasAccess } from './canUtil';

const mapStateToProps = (state: Global) => {
  const permissionsObject = selectPermissionsObject(state);
  const accountSettings = accountSelectors.getAccountSettings(state) || {};
  const accountFeatures = accountSelectors.getAccountFeatures(state) || {};
  const hasRecordingEnabled = _get(accountSettings, 'recordingEnabled', false); // turned on by admin
  const hasStreamingEnabled = _get(accountFeatures, 'streaming', false); // turned on by ???
  const recordingsAuthSettings = recordingsAuthSelectors.vcSettingsSelector(state) || {};
  const recordingsAuthSettingsData = _get(recordingsAuthSettings, 'data') || {};
  const recordingStatus = _get(recordingsAuthSettingsData, 'recordingStatus');
  const liveStreamingStatus = _get(recordingsAuthSettingsData, 'liveStreamingStatus');
  const recordingStatusActive = activeFeatureStatus.includes(recordingStatus);
  const liveStreamingStatusActive = activeFeatureStatus.includes(liveStreamingStatus);
  // set permissions
  let deepCopyPermissionsObject = _cloneDeep(permissionsObject);
  deepCopyPermissionsObject = deepCopyPermissionsObject
    .set(PermissionTypes.ACCOUNT_RECORDINGS, recordingStatusActive)
    .set(PermissionTypes.ACCOUNT_STREAMING, liveStreamingStatusActive)
    .set(PermissionTypes.VIEW_RECORDINGS, hasRecordingEnabled && recordingStatusActive)
    .set(PermissionTypes.VIEW_STREAMING, hasStreamingEnabled && liveStreamingStatusActive);

  return {
    permissionsObject: deepCopyPermissionsObject
  };
};

interface Props {
  permissionsObject: PermissionsState;
  userAccess: PermissionTypes[];
  children?: JSX.Element;
}
class CanComponent extends React.PureComponent<Props>  {

  render() {
    const {
      permissionsObject,
      userAccess,
      children
    } = this.props;
    if (hasAccess(userAccess, permissionsObject)) {
      return (
        <>
          {children}
        </>
      );
    }
    return <React.Fragment />;
  }
}

export default connect(mapStateToProps)(CanComponent);
